<template>
  <div>
    <!-- BODY -->
    <div class="modal-body">
      <div class="col-lg-8 mx-auto p-0">
        <article
          class="news-article bg-white rounded-2 shadow-lg overflow-hidden"
        >
          <div v-if="data" class="full-post-content p-4">
            <div class="d-flex align-items-center vertical-align-middle justify-content-left">
              <p class="text-muted small mb-0">
                Đăng bởi:&nbsp;{{ data.nameAuthor }}
                <span class="ms-2">|</span>
                <i class="fas fa-calendar-alt ms-2"/>
                {{ formatDate(data.createdAt) }}
              </p>
            </div>

            <hr />
            <p class="content-text-full fw-bold fs-5 text-dark">
              {{ data.describe }}
            </p>

            <!-- Hiển thị ảnh lớn hơn (nếu cần) -->
            <div class="mt-0">
              <div class="event-image-wrapper">
                <div v-if="data.fileImage?.fileId">
                  <ZoomableImage
                      :canClick="true"
                      :currentImageSrc="url + data.fileImage.fileId"
                      maxPreviewHeight="100%"
                      maxModalImageHeight="750px"
                      :smallImageWrapperStyle="{
                  cursor: 'pointer',
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  borderRadius: '20px 0 0 !important',
                }"
                      :smallImageStyle="{
                  width: '100%',
                  height: '100%',
                  'object-fit': 'cover',
                  'border-radius': '12px 12px 0 0',
                  transition: 'transform 0.3s ease, opacity 0.3s ease',
                  margin: '0',
                }"
                  >
                  </ZoomableImage>
                </div>
              </div>

          </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { ButtonCore, ZoomableImage } from "@/components/widgets";

export default {
  components: {
    ZoomableImage,
  },
  props: { data: Object },
  data() {
    return {
      showImageModal: false,
      currentImageSrc: "",
      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("vi-VN");
    },
  },
};
</script>

<style scoped>
/* ===============================
   ARTICLE MAIN WRAPPER
================================*/
.news-article {
  border-radius: 1rem;
  overflow: hidden;
  background: #fff;
}
/* ... (các style khác) ... */
/* Sử dụng .vintage-card (định nghĩa cuối cùng và chi tiết hơn) */

/* ======================== 1. KHUNG CHUNG VÀ BỐ CỤC ======================== */
.horizontal-list-container {
  /* Giữ định nghĩa cuối cùng. Padding sẽ được điều chỉnh trong Media Queries */
  padding: 0px 25px 30px 25px;
  background-color: rgba(255, 255, 255, 0.12);
}

.item-slide {
  padding: 10px;
  justify-content: center;
  align-items: center;
}

.event-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

/* Sử dụng .vintage-card (định nghĩa cuối cùng và chi tiết hơn) */
.event-card,
.vintage-card {
  /* Gộp thuộc tính của .event-card và .vintage-card */
  background: #fcf7ed;
  border-radius: 20px !important;
  /* border: 1px solid #e0d9c8; */
  box-shadow: 0 6px 12px rgba(100, 80, 50, 0.1);
  /* overflow: inherit; */
  transition: all 0.3s ease;
  /* Flexbox để đảm bảo chiều cao đồng đều */
  display: flex;
  flex-direction: column;
  height: 100%;

  /* Min-height sẽ được điều chỉnh trong responsive media queries */
  min-height: 200px;
}

/* ======================== 2. HÌNH ẢNH ======================== */
.event-image-wrapper {
  position: relative;
  /* Kỹ thuật Aspect Ratio (3:2) */
  padding-bottom: 66.66%; /* Chiều cao = 2/3 chiều rộng */
  height: 0; /* Đặt height về 0 */
  overflow: hidden;
  background: transparent;
  transition: transform 0.3s ease, opacity 0.3s ease;
  border-radius: 12px 12px 0 0; /* Áp dụng bo góc cho wrapper */
}

.event-card:hover .event-image-wrapper,
.vintage-card:hover .event-image-wrapper {
  transform: scale(1);
  opacity: 0.9;
}

/* ======================== 3. NHÃN/TAG ======================== */
.event-type-tag {
  display: inline-flex;
  vertical-align: middle;
  align-items: flex-start;
  /* background: rgba(90, 60, 40, 0.9); */
  color: var(--color-dark);
  font-size: 0.85rem;
  /* padding: 6px 12px; */
  /* border-radius: 20px; */
  font-family: "Montserrat", serif;

  font-weight: 600; /* Thêm lại font-weight nếu cần */
  margin-top: 0px;
}

/* ======================== 4. NỘI DUNG CHÍNH ======================== */


.event-content {
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  font-family: "Poppins_Light", serif !important;
  color: var(--color-dark);
}

.event-title {
  text-align: justify;
  font-size: 1.1rem;
  line-height: 1.2;
  height: 50px;
  margin: 0 10px 0;
  font-weight: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.post-date {
  font-size: 0.75rem; /* Kích thước nhỏ */
  color: var(--color-space) !important;
  font-weight: 500;
  margin-top: 0;
}

.content-text-full{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  font-family: "Poppins_Light", Inter !important;

  color: var(--color-dark);
}
/* ========================================
   RESPONSIVE CAROUSEL EVENT LIST
   ======================================== */

/* Extra Small Devices (Mobile < 576px) */
@media (min-width: 320px) and (max-width: 374px) {

  .event-image-wrapper {
    padding-bottom: 75%; /* Tỉ lệ 4:3 (75%) */
  }

}
@media (min-width: 375px) and (max-width: 474px) {

  .event-image-wrapper {
    height: 200px;
  }

}
/* Small Devices (Lớn hơn điện thoại) & Portrait Tablets (475px - 767px) */
@media (min-width: 475px) and (max-width: 767.98px) {


  .event-image-wrapper {
    padding-bottom: 66.66%; /* Giữ tỉ lệ 3:2 */
  }


}
/* Medium Devices (Tablets, 768px - 991px) */
@media (min-width: 768px) and (max-width: 991.98px) {

  .event-image-wrapper {
    padding-bottom: 66.66%;
  }

}
/* Large Devices (Laptops, 992px - 1199px) */
@media (min-width: 992px) and (max-width: 1199.98px) {

  .event-image-wrapper {
    padding-bottom: 66.66%;
  }

}
/* Extra Large Devices (Desktop/TV, ≥ 1200px) */
@media (min-width: 1200px) {

  .event-image-wrapper {
    padding-bottom: 68%;
  }

}



</style>
